import { InjectionToken } from '@angular/core';

import { JobBoardType } from './job-boards.enums';

interface JobBoardBase {
  id: number;
  logoUrl: string;
  codename: string;
  name: string;
  position: number;
  website: string;
}

export interface JobBoard extends JobBoardBase {
  type: JobBoardType.Manual;
  category: string;
  description: string;
  location: string;
  premium: boolean;
  provider: string;
  requireAdditionalOptions: boolean;
  originalPrice?: number;
  price?: number;
  currency?: string;
  loading?: boolean;
  providerMappings?: any;
  autoPostingDisabled?: boolean;
}

export interface AutoPostedJobBoard extends JobBoardBase {
  type: JobBoardType.Auto;
}

export interface JobBoardElementTranslations {
  postingDisabled: string;
  postingDisabledInfo: string;
  errorInfo: string;
  publish: string;
}

export type SettingsLink = {
  path: string[];
  queryParams: { [key: string]: string };
};

export const JobBoardElementTranslationsToken = new InjectionToken<JobBoardElementTranslations>(
  'Translations for JobBoardElement',
);

export enum JobBoardCodename {
  Fashionunited = 'fashionunited',
  Linkedin = 'linkedin-limited-listings',
  CodyGr = 'cody-gr',
  MyJobBoardHelper = 'my-job-helper',
  Jobissim = 'jobissim',
  Glassdoor = 'glassdoor',
}
